import { NgModule } from '@angular/core';
import { LucideAngularModule, LucideIconConfig } from 'lucide-angular';
import { APP_ICONS, ICON_DEFAULT_SIZE, ICON_DEFAULT_STROKE_WIDTH } from './icons';
import { IconDirective } from './icon.directive';

@NgModule({
  declarations: [IconDirective],
  imports: [LucideAngularModule.pick(APP_ICONS)],
  exports: [LucideAngularModule, IconDirective]
})
export class IconsModule {
  constructor(config: LucideIconConfig) {
    config.size = ICON_DEFAULT_SIZE;
    config.strokeWidth = ICON_DEFAULT_STROKE_WIDTH;
  }
}
